import { render, staticRenderFns } from "./taskStatus.vue?vue&type=template&id=3751b6ca&scoped=true"
import script from "./taskStatus.vue?vue&type=script&lang=ts"
export * from "./taskStatus.vue?vue&type=script&lang=ts"
import style0 from "./taskStatus.vue?vue&type=style&index=0&id=3751b6ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_idpt5aadqkxzu6szyh7dhosqta/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3751b6ca",
  null
  
)

export default component.exports